var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.value == "premium" ? _c("div", {
    staticClass: "add-premium"
  }, [_c("a-form-model", {
    ref: "price",
    staticClass: "plan-form1",
    attrs: {
      model: _vm.form,
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 20
      },
      rules: _vm.dataRule
    }
  }, [_c("a-form-model-item", {
    ref: "price2",
    staticClass: "box",
    staticStyle: {
      "align-items": "flex-start",
      "margin-bottom": "10px"
    },
    attrs: {
      label: _vm.$t("保费"),
      prop: "price"
    }
  }, [_c("div", {
    staticClass: "cont"
  }, [_c("a-input", {
    staticStyle: {
      width: "20%"
    },
    attrs: {
      placeholder: _vm.$t("单位") + "：" + _vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId, false))
    },
    on: {
      blur: _vm.emitInfo,
      change: function ($event) {
        return _vm.textChange("priceMin");
      }
    },
    model: {
      value: _vm.form.priceMin,
      callback: function ($$v) {
        _vm.$set(_vm.form, "priceMin", $$v);
      },
      expression: "form.priceMin"
    }
  }), _c("span", {
    staticStyle: {
      margin: "0 10px",
      height: "32px",
      "line-height": "32px"
    }
  }, [_vm._v(" ~ ")]), _c("a-input", {
    staticStyle: {
      width: "20%"
    },
    attrs: {
      placeholder: _vm.$t("单位") + "：" + _vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId, false)),
      disabled: _vm.form.priceMin ? false : true
    },
    on: {
      blur: _vm.emitInfo,
      change: function ($event) {
        return _vm.textChange("priceMax");
      }
    },
    model: {
      value: _vm.form.priceMax,
      callback: function ($$v) {
        _vm.$set(_vm.form, "priceMax", $$v);
      },
      expression: "form.priceMax"
    }
  }), _c("span", {
    staticStyle: {
      display: "inline-block",
      color: "red",
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.$t("注：小数点之后最多输入两位")))])], 1)])], 1), _vm.showAreaTable ? _c("div", {
    staticStyle: {
      color: "#1890ff",
      margin: "0 0 10px 70px"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("使用区域保费模版时，请至少添加俩条保费数据")) + " ")]) : _vm._e(), _vm.showAreaTable ? _c("a-table", {
    staticStyle: {
      margin: "0 70px"
    },
    attrs: {
      size: "small",
      pagination: false,
      bordered: "",
      columns: _vm.templateColumn,
      "data-source": _vm.templateData,
      align: "center",
      rowKey: "i",
      rowClassName: _vm.tableRowClass
    },
    scopedSlots: _vm._u([{
      key: "areaName",
      fn: function (_, record, index) {
        return [_vm._v(" " + _vm._s(record.areaName) + " "), _c("div", {
          staticClass: "area",
          on: {
            click: function ($event) {
              return _vm.openArea(index);
            }
          }
        }, [_vm._v("+ " + _vm._s(_vm.$t("选择区域")))])];
      }
    }, {
      key: "price",
      fn: function (_, record, index) {
        return [_c("a-input", {
          staticStyle: {
            width: "80%"
          },
          on: {
            blur: function ($event) {
              return _vm.changePrice(record.price);
            },
            change: function ($event) {
              return _vm.textTemplateChange(index);
            }
          },
          model: {
            value: record.price,
            callback: function ($$v) {
              _vm.$set(record, "price", $$v);
            },
            expression: "record.price"
          }
        })];
      }
    }, {
      key: "operation",
      fn: function (text, record, i) {
        return [_c("a-button", {
          attrs: {
            size: "small",
            type: "danger"
          },
          on: {
            click: function ($event) {
              return _vm.delArea(i);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("删除")))])];
      }
    }], null, false, 1251223733)
  }, _vm._l(_vm.templateColumn, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0) : _vm._e(), _vm.showAreaTable ? _c("div", {
    staticClass: "add-area",
    on: {
      click: _vm.addAreaPremium
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t("新增") + _vm.$t("区域保费")))]) : _vm._e(), _c("a-modal", {
    staticClass: "plan-area",
    attrs: {
      title: _vm.$t("选择区域"),
      visible: _vm.areaVisible,
      maskClosable: false,
      width: 800
    },
    on: {
      cancel: function ($event) {
        _vm.areaVisible = false;
      }
    }
  }, [_c("a-cascader", {
    staticStyle: {
      width: "50%",
      "margin-bottom": "20px"
    },
    attrs: {
      options: _vm.areaList,
      "field-names": {
        label: "name",
        value: "code",
        children: "child",
        disabled: "disabled"
      },
      placeholder: _vm.$t("请选择") + _vm.$t("区域")
    },
    on: {
      change: _vm.addAreaList
    },
    model: {
      value: _vm.currentArea,
      callback: function ($$v) {
        _vm.currentArea = $$v;
      },
      expression: "currentArea"
    }
  }), _vm._l(_vm.showArea, function (item, i) {
    return _c("div", {
      key: i,
      staticClass: "list"
    }, [_c("span", {
      staticStyle: {
        "text-align": "justify",
        "text-align-last": "justify"
      }
    }, [_vm._v(_vm._s(item.name) + "：")]), _c("div", {
      staticClass: "list-tag"
    }, _vm._l(item.city, function (item1, i1) {
      return _c("a-tag", {
        key: item1.code,
        attrs: {
          color: "blue"
        }
      }, [_vm._v(" " + _vm._s(item1.name) + " "), _c("span", {
        staticStyle: {
          cursor: "pointer",
          "margin-left": "5px"
        },
        on: {
          click: function ($event) {
            return _vm.delAreaItem(i, i1);
          }
        }
      }, [_vm._v("X")])]);
    }), 1)]);
  }), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.saveArea
    }
  }, [_vm._v(_vm._s(_vm.$t("保存")))])], 1)], 2)], 1) : _vm.value == "additional" && _vm.attachData.length != 0 ? _c("div", {
    staticClass: "add-additional"
  }, [_c("a-form-model", {
    ref: "form",
    staticClass: "plan-form1",
    attrs: {
      model: _vm.form,
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 20
      },
      rules: _vm.dataRule
    }
  }, [_c("a-form-model-item", {
    staticClass: "box",
    staticStyle: {
      "align-items": "flex-start",
      "margin-bottom": "10px"
    },
    attrs: {
      label: _vm.$t("附加险")
    }
  }, [_c("div", {
    staticClass: "cont"
  }, [_c("a-select", {
    attrs: {
      mode: "multiple",
      showSearch: "",
      "option-filter-prop": "label",
      placeholder: _vm.$t("请选择") + _vm.$t("附加险"),
      allowClear: "",
      getPopupContainer: triggerNode => triggerNode.parentNode
    },
    on: {
      deselect: _vm.ondeselect,
      change: _vm.changeAttach
    },
    model: {
      value: _vm.form.attach,
      callback: function ($$v) {
        _vm.$set(_vm.form, "attach", $$v);
      },
      expression: "form.attach"
    }
  }, _vm._l(_vm.attachData, function (item) {
    return _c("a-select-option", {
      key: item.attachId,
      attrs: {
        value: item.attachId.toString(),
        label: item.name
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1)])], 1), _vm.form.attach && _vm.form.attach.length ? _c("a-table", {
    staticStyle: {
      margin: "0 70px 20px"
    },
    attrs: {
      size: "small",
      pagination: false,
      bordered: "",
      columns: _vm.additionalColumn,
      "data-source": _vm.additionalData,
      align: "center",
      rowKey: "attachId"
    },
    scopedSlots: _vm._u([{
      key: "buyLimit",
      fn: function (_, record, i) {
        return [_c("a-radio-group", {
          staticStyle: {
            margin: "0"
          },
          on: {
            change: function ($event) {
              return _vm.changeType($event, record, i);
            }
          },
          model: {
            value: record.buyLimit,
            callback: function ($$v) {
              _vm.$set(record, "buyLimit", $$v);
            },
            expression: "record.buyLimit"
          }
        }, [_c("a-radio", {
          attrs: {
            value: 1
          }
        }, [_vm._v(_vm._s(_vm.$t("必购")))]), _c("a-radio", {
          attrs: {
            value: 0
          }
        }, [_vm._v(_vm._s(_vm.$t("选购")))])], 1)];
      }
    }, {
      key: "operation",
      fn: function (_, record, i) {
        return [_c("a-button", {
          attrs: {
            size: "small",
            type: "danger"
          },
          on: {
            click: function ($event) {
              return _vm.delAdditionalData(record, i);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("删除")))])];
      }
    }], null, false, 530760934)
  }, [_vm._l(_vm.additionalColumn, function (item, i) {
    var _item$slots4, _item$slots5, _item$slots6;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots4 = item.slots) === null || _item$slots4 === void 0 ? void 0 : _item$slots4.title
      },
      slot: (_item$slots5 = item.slots) === null || _item$slots5 === void 0 ? void 0 : _item$slots5.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots6 = item.slots) === null || _item$slots6 === void 0 ? void 0 : _item$slots6.title)))]);
  }), _c("template", {
    slot: "保费"
  }, [_vm._v(" (" + _vm._s(_vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId, false))) + ") ")])], 2) : _vm._e()], 1) : _vm.value == "clause" ? _c("div", {
    staticClass: "add-clause"
  }, [_c("a-form-model", {
    ref: "clauses",
    staticClass: "plan-form1",
    attrs: {
      model: _vm.form,
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 20
      },
      rules: _vm.dataRule
    }
  }, [_c("a-form-model-item", {
    ref: "clause",
    staticClass: "box",
    staticStyle: {
      "align-items": "flex-start",
      "margin-bottom": "10px"
    },
    attrs: {
      prop: "clause",
      label: _vm.$t("条款文件")
    }
  }, [_c("a-select", {
    staticClass: "cont",
    attrs: {
      showSearch: "",
      "option-filter-prop": "label",
      placeholder: _vm.$t("请选择") + _vm.$t("条款文件"),
      getPopupContainer: triggerNode => triggerNode.parentNode
    },
    on: {
      change: _vm.changeClause
    },
    model: {
      value: _vm.form.clause,
      callback: function ($$v) {
        _vm.$set(_vm.form, "clause", $$v);
      },
      expression: "form.clause"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 0,
      label: _vm.$t("全部")
    }
  }, [_vm._v(_vm._s(_vm.$t("全部")))]), _vm._l(_vm.termsData, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id,
        label: item.name
      }
    }, [_vm._v(_vm._s(item.name))]);
  })], 2), _vm._l(_vm.checkedAdditionalList, function (item, i) {
    return _c("a-tag", {
      key: i,
      attrs: {
        color: "blue"
      }
    }, [_vm._v(" " + _vm._s(item.name) + " "), _c("span", {
      staticStyle: {
        cursor: "pointer",
        "margin-left": "5px"
      },
      on: {
        click: function ($event) {
          return _vm.delClause(item.id, i);
        }
      }
    }, [_vm._v("X")])]);
  })], 2)], 1)], 1) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };